import { ConfigQuery, ExtraServicesFoMerchantResponse, fetchExtraServicesFoMerchant } from "../../../createOrderApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { CreateOrderDialogType } from "../../../createOrderTypes"
import { ExtraServicesContent } from "./ExtraServicesContent"

const transformData = (data: ExtraServicesFoMerchantResponse) => {
    return data.services || []
}

type ExtraServicesProps = Readonly<{
    userId: number
    dialogType: CreateOrderDialogType
}>

export function ExtraServices({ userId, dialogType }: ExtraServicesProps) {
    const { data: services = [], isFetched } = useApiQuery(fetchExtraServicesFoMerchant, {
        queryName: ConfigQuery.EXTRA_SERVICES_FOR_MERCHANT,
        dependencies: {
            merchantId: userId,
        },
        select: transformData,
        enabled: !!userId,
    })
    if (!isFetched || services.length === 0) return null

    return <ExtraServicesContent services={services} dialogType={dialogType} />
}
